import { LeadsListV2 } from "../../features/leads/components/LeadsList";
import { useMemo, useState } from "react";
import { SearchInput } from "@components/ui/SearchInput";
import useLeads from "features/leads/customHooks/useLeads";
import CSVDownloadButton from "features/downloadCsv/DownloadToCsv";
import { MultiSelect } from "@components/ui/MultiSelect";
import {INDIAN_CITIES} from "../../features/loanApplications/formFieldsConfig/indiaStatesList"

export const LeadListPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  var { leads, isLoading } = useLeads();

  const filteredLeads = useMemo(() => {
    return leads.filter(
      ({ firstName, lastName, phoneNumber, email, city }) => {
        const matchesSearch =
          firstName?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
          lastName?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
          phoneNumber?.includes(searchQuery) ||
          email?.toLowerCase()?.includes(searchQuery.toLowerCase());
  
        const matchesCity =
          selectedStatuses.length === 0 || selectedStatuses.includes(city);
  
        return matchesSearch && matchesCity;
      }
    );
  }, [searchQuery, isLoading, leads, selectedStatuses]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="h-full flex-1 flex-col md:flex">
      <div className="flex items-center justify-center md:justify-between mb-3">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Welcome back!</h2>
          <p className="text-muted-foreground">
            Here&apos;s a list of all the Leads!
          </p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-1 px-0">
        <SearchInput
          searchQuery={searchQuery}
          handleSearchChange={handleSearchChange}
          className="rounded-lg px-12 text-muted-foreground"
        />
        <MultiSelect
          options={INDIAN_CITIES}
          selected={selectedStatuses}
          onChange={setSelectedStatuses}
          placeholder="Filter by cities..."
          className="md:w-[350px]"
        />
        <CSVDownloadButton data={filteredLeads} filename="leads.csv" />
      </div>
      <LeadsListV2
        searchQuery={searchQuery}
        filteredLeads={filteredLeads}
        isLoading={isLoading}
      />
    </div>
  );
};
